import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SignContractModal } from '../../../common/modals';
import { contractType, contractTypeT } from '../../../common/enums';
import { connectModal } from '../../../features/modal/hoc';
import { selectData } from '../../../features/modal/ducks';
import { selectToken, signAutoInvestActions } from '../../../features/auth/ducks';
import { signAllocationActions } from '../ducks';
import { apiCallIds } from '../api';
import { getFileUrl } from '../../../common/utils/helpers';

const mapStateToProps = state => ({
  allocation: selectData(state, apiCallIds.SIGN_ALLOCATION),
  token: selectToken(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signAllocation: signAllocationActions.request,
      signAutoInvest: signAutoInvestActions.request
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.SIGN_ALLOCATION)
@translate()
export default class SignAllocation extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    allocation: PropTypes.object,
    token: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = () => {
    const { actions, allocation } = this.props;
    if (allocation.contracts){
      actions.signAllocation({ allocationId: allocation.id });
    }
    if (allocation.contract) { // testing purposes
      actions.signAutoInvest({accountId: allocation.accountId})
    }
  };

  render() {
    const { isVisible, isLoading, modalActions, token, allocation,t } = this.props;

    if (!isVisible && !allocation) {
      return null;
    }

    let contract = null
    if (allocation.contracts){
      contract = allocation.contracts.find(a => a.type === contractType.MANDATE);
    }

    if(allocation.contract){
      contract = allocation.contract
    }


    if (!contract) {
      return null;
    }

    return (
      <SignContractModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        fileLocation={getFileUrl(contract.fileId, token)}
        title={contractTypeT.MANDATE_CREDITOR}
        text={t(
          'Investor sa oboznámil so znením Záväzného pokynu investovať, rozumie mu, súhlasí s jeho znením a berie na vedomie všetky jeho účinky ako aj všetky práva a povinnosti z neho vyplývajúce. Je si vedomý, že kliknutím na tlačidlo "Podpísať Záväzný pokyn investovať" je táto zmluva pre investora v celom svojom rozsahu záväzná.'
        )}
        checkboxText={t('Súhlasím so Záväzným pokynom investovať')}
        buttonText={t('Podpísať Záväzný pokyn investovať')}
        fileLinktext={t('Prečítať Záväzný pokyn')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/SignAllocation.js